export function formatDisplayDate(value) {
  if (value === null || value === undefined || value === '') return '';
  const date = String(value).match(/^(\d{4})-(\d{2})-(\d{2})(?:$|[T ])/);
  if (!date) return String(value);
  const [, year, month, day] = date;
  if (month === '00' || day === '00') return '';
  return `${day}-${month}-${year}`;
}